import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip-sqp',
  templateUrl: './custom-tooltip-sqp.component.html',
  styleUrls: ['./custom-tooltip-sqp.component.css']
})
export class CustomTooltipSqpComponent implements OnInit {

  @Input() textoTooltip:string;
  @Input() posicion:string;

  constructor() { }

  ngOnInit(): void {
  }

}
